<template>
  <div>
    <el-form
      ref="entity"
      :inline="true"
      :model="entity"
      :rules="rules"
      class="demo-form-inline"
    >

      <el-row>
        <el-col :span="6">
          <el-form-item label="分类" prop="fileTypeDictKey">
            <el-select
              v-model="entity.fileTypeDictKey"
              size="small"
              clearable
              style="width: 100%;"
            >
              <el-option
                v-for="item in getComboxData('D83')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注">
            <el-input
              v-model="entity.remark"
              placeholder="请输入备注"
              size="small"
              clearable
              style="width: 100%;"
            />
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-button ref="btnSelectFile" size="small" type="primary" @click="handleSelectFile">点击上传</el-button>
          <span>单文件不超过100M(office文件、图片文件、.pdf .rar .zip .txt 文件)</span>
          <el-upload
            ref="upload"
            class="upload-demo"
            :action="uploadUrl"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :data="myData"
            :headers="myHeader"
            :on-success="handleOnSuccess"
            :on-error="handleOnError"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-progress v-if="dlProgress>0" :text-inside="true" :stroke-width="18" :percentage="dlProgress" status="success" style="margin-bottom:10px" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            class="table-list"
            :border="true"
            :data="tableData"
            style="width: 100%"
          >
            <!-- 类型 -->
            <el-table-column
              prop="fileTypeDictKey"
              label="类型"
              width="120"
            >
              <template slot-scope="scope">
                <div>
                  <span v-if="!scope.row.isEdit">{{ scope.row.fileTypeDictKeyItemName }}</span>
                  <el-select
                    v-if="scope.row.isEdit"
                    v-model="scope.row.fileTypeDictKey"
                    clearable
                    filterable
                    placeholder="请选择类型"
                    size="small"
                  >
                    <el-option
                      v-for="item in getComboxData('D83')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <!-- 备注 -->
            <el-table-column
              prop="remark"
              label="备注"
              width="250"
            >
              <template slot-scope="scope">
                <div>
                  <span v-if="!scope.row.isEdit">{{ scope.row.remark }}</span>
                  <el-input
                    v-if="scope.row.isEdit"
                    v-model="scope.row.remark"
                    size="small"
                    placeholder="请输入备注"
                  />
                </div>
              </template>
            </el-table-column>
            <!-- 文件 -->
            <el-table-column
              prop="fileName"
              label="文件"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="handleDownload(scope.row)">{{ scope.row.fileName }}</el-button>
              </template>
            </el-table-column>
            <!-- 大小 -->
            <el-table-column
              prop="fileSize"
              label="大小(K)"
              width="100"
            />
            <!-- 上传者 -->
            <el-table-column
              prop="creatorUserName"
              label="上传者"
              width="100"
            />
            <!-- 上传时间 -->
            <el-table-column
              prop="creationTimeShow"
              label="上传时间"
              width="150"
            />
            <el-table-column
              fixed="right"
              label="操作"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.isEdit"
                  type="text"
                  size="mini"
                  plain
                  @click.stop="handleEdit( scope.row,scope.$index)"
                >
                  修改
                </el-button>
                <el-button
                  v-if="scope.row.isEdit"
                  type="text"
                  size="small"
                  @click.stop="handleSave(scope.row)"
                >
                  保存
                </el-button>
                <el-button
                  v-if="scope.row.isEdit"
                  type="text"
                  size="small"
                  @click.stop="handleCancel(scope.row ,scope.$index)"
                >
                  取消
                </el-button>
                <el-button
                  v-if="!scope.row.isEdit"
                  type="text"
                  size="mini"
                  @click.stop="handleDel(scope.row)"
                >
                  删除
                </el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import config from '@/config'
import KxjCom from '@/utils/kxjcom'
import LoadingOptions from '@/components/commonSetting'
// import api from '@/api/index.js'
import axios from 'axios'

export default {
  props: {
  },
  data() {
    return {

      allComboxData: [],
      formHasError: false,
      baseURL: config.apiHost,
      entity: {
        moduleCode: '',
        moduleKey: null,
        fileTypeDictKey: '',
        remark: ''
      },
      rules: {
        fileTypeDictKey: [
          { required: true, message: '请选择附件类型', trigger: 'blur,change' }
        ]
      },
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 100,
        sortKey: '',
        sortOrder: '',
        moduleCode: '',
        moduleKey: null
      },
      tableData: [],
      dlProgress: 0,
      fileList: [{ name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }, { name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }]
    }
  },
  computed: {
    myHeader() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
      }
    },
    myData() {
      return this.entity
    },
    uploadUrl() {
      return this.baseURL + '/api/EndUserInfo/UploadUserFile'
    },
    getDownLoadUrl(id) {
      return this.baseURL + '/api/EndUserInfo/DownloadUserFile?id=' + id
    }
  },
  created() {
    this.$bus.off('handleInitAppendix')
    this.$bus.on('handleInitAppendix', this.init)

    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D83').then(res => {
      this.allComboxData = res.data.result
    })
  },

  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    init() {
      this.entity.moduleCode = this.$route.params.moduleCode
      this.entity.moduleKey = this.$route.params.id
      this.searchForm.moduleCode = this.$route.params.moduleCode
      this.searchForm.moduleKey = this.$route.params.id
      if (!this.entity.moduleCode || !this.entity.moduleKey) {
        this.$message.error('参数错误')
      }
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GzTempFile/GetPagedListgzTempFiles'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.tableData = res.data.result.items
        })
    },
    // 编辑
    handleEdit(row) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].isEdit) {
          if (this.tableData[i].id) {
            this.tableData[i].isEdit = false
          } else {
            this.tableData.splice(i, 1)
            i--
          }
        }
        row.isEdit = true
      }
    },
    // 取消
    handleCancel(row, index) {
      row.isEdit = false
      if (!row.id) {
        this.tableData.splice(index, 1)
      }
    },
    // 删除
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/GzTempFile/DeletegzTempFile'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    // 新建或修改信息就是保存的时候
    handleSave(row) {
      if (!row.fileTypeDictKey) {
        this.$message.error('请输入计划名称')
        return false
      }
      const that = this
      var obj = { entityData: row }
      this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/GzTempFile/CreateOrUpdategzTempFile'
      pathReq.postForm(path, obj).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.handleSearch()
          }
        }
      })
    },
    /** 选择文件 */
    handleSelectFile(file) {
      var that = this
      that.$refs['entity'].validate(valid => {
        if (!valid) {
          return false
        } else {
          that.$refs['upload'].$refs['upload-inner'].handleClick()
        }
      })
    },
    handleBeforeUpload(file) {
      if (file.size > 100 * 1000 * 1024) {
        this.$message.error('文件大于100M')
        return false
      }
    },
    handleOnSuccess() {
      this.$message.success('上传文件成功')
      this.handleSearch()
    },
    handleOnError(ret) {
      console.log(ret)

      this.$message.error('上传文件失败,请确认文件大小与文件格式')
    },
    handleDownload(row) {
      const that = this
      const loading = that.$loading(LoadingOptions.loadOptions)
      const url = this.baseURL + '/api/EndUserInfo/DownloadUserFile?id=' + row.id
      const h = that.myHeader
      that.dlProgress = 0
      axios({
        method: 'post',
        url: url,
        // data: { id: row.id },
        responseType: 'blob',
        headers: h, // 敲黑板
        onDownloadProgress(progress) {
          that.dlProgress = Math.round(progress.loaded / progress.total * 100)
        }
      })
        .then((res) => {
          var content = res.data
          var blob = new Blob([content])
          var fileName = row.fileName // 要保存的文件名称
          if ('download' in document.createElement('a')) {
          // 非IE下载
            var elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else {
          // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }

          loading.close()
          this.$message.success('下载成功')
        })
        .catch(() => {
          loading.close()
        })

      // const data = { Id: row.id }
    //   api.post('/api/EndUserInfo/DownloadUserFile1?id=' + row.id,
    //     {
    //       responseType: 'blob'
    //     }
    //   //  {
    //     // method: 'post',
    //     // url: this.baseUrl + '/api/EndUserInfo/DownloadUserFile',
    //     // data: { id: row.id },
    //     // responseType: 'blob',
    //     // // 敲黑板
    //     // onDownloadProgress(progress) {
    //     //   that.dlProgress = Math.round(progress.loaded / progress.total * 100)
    //     // }
    //   )
    //     .then((res) => {
    //       console.log(res)
    //       const fileName = decodeURI(res.headers['content-disposition'].split('=')[1])
    //       const url = window.URL.createObjectURL(new Blob([res.data]))
    //       const link = document.createElement('a')
    //       link.style.display = 'none'
    //       link.href = url
    //       link.setAttribute('download', fileName)
    //       document.body.appendChild(link)
    //       link.click()
    //       this.$message.success('下载成功')
    //       loading.close()
    //     })
    //     .catch(() => {
    //       loading.close()
    //     })
    }

  }
}
</script>
